import { render, staticRenderFns } from "./AgregarUsuario.vue?vue&type=template&id=0b204b35&"
import script from "./AgregarUsuario.vue?vue&type=script&lang=js&"
export * from "./AgregarUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports